import React from 'react';
import styles from './fishing_report_button.less';

import { PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useResponsive } from '../../hooks/use_responsive';

import { FishingReportModalActions } from '../../redux/fishing_report_modal';
import { OmniaButton } from '../omnia_button/omnia_button';

interface FishingReportButtonProps {
  fishingReportsCount: number;
  isHeaderSticky: boolean;
}

export const FishingReportButton = (props: FishingReportButtonProps) => {
  const { fishingReportsCount, isHeaderSticky } = props;
  const { isMobile, isDesktop } = useResponsive();

  const dispatch = useDispatch();

  const headerIsNotSticky = !isHeaderSticky;
  const hasFishingReports = fishingReportsCount > 0;
  const showFishingReportCount = hasFishingReports && headerIsNotSticky && isDesktop;

  const fileFishingReport = () => {
    dispatch(FishingReportModalActions.FISHING_REPORT_MODAL_OPEN());
  };
  return (
    <div className={styles.headerColFishingReport}>
      <div
        className={classNames(styles.fileReportButton, {
          [styles.fileReportButton__stickyMobile]: isMobile && isHeaderSticky,
        })}
      >
        <OmniaButton
          size="lg"
          kind="tertiary"
          fontSize={14}
          onPress={() => {
            fileFishingReport();
            // to do: add analytics to state page in upcoming story
            // WebAnalytics.lakePageClick('[overview].(fishing_reports)', webAnalyticsLakeClickArgs);
          }}
          shape={isHeaderSticky && isMobile ? 'square' : 'rectangle'}
        >
          <PlusOutlined /> {isDesktop && 'File a Fishing Report'}
          {isMobile && headerIsNotSticky && 'File Report'}
        </OmniaButton>
      </div>
      {showFishingReportCount && (
        <span className={styles.fishingReportCount}>
          {fishingReportsCount} Fishing Report{fishingReportsCount > 1 && 's'}
        </span>
      )}
    </div>
  );
};
